const DETECTORS = [
    {
        label: "angeion test domains",
        regex: /([A-Za-z0-9.-]*angeiontest\.com)/gi,
    },
    {
        label: "localhost references",
        regex: /(localhost(?::\d+)?)/gi,
    },
];

function findMatches(serializedPayload) {
    return DETECTORS.map((detector) => {
        const matches = new Set();
        // Create a fresh RegExp to reset lastIndex (shared DETECTORS use the `g` flag).
        const matcher = new RegExp(detector.regex.source, detector.regex.flags);
        let match;

        while ((match = matcher.exec(serializedPayload)) !== null) {
            matches.add(match[1] ?? match[0]);
        }

        if (matches.size === 0) {
            return null;
        }

        return {
            label: detector.label,
            matches: Array.from(matches).sort(),
        };
    }).filter(Boolean);
}

function formatMatches(matches) {
    return matches
        .map(
            (hit) =>
                `${hit.label}: ${hit.matches
                    .map((value) => `"${value}"`)
                    .join(", ")}`
        )
        .join("; ");
}

export function registerAppDocketGuard({ appDocketAPI }) {
    if (registerAppDocketGuard.registered || typeof window === "undefined") {
        return;
    }

    if (typeof window.fetch !== "function") {
        return;
    }

    registerAppDocketGuard.registered = true;
    const originalFetch = window.fetch.bind(window);

    window.fetch = async (...args) => {
        const response = await originalFetch(...args);

        const [input] = args;
        const requestUrl =
            typeof input === "string"
                ? input
                : typeof input?.url === "string"
                  ? input.url
                  : null;

        if (!requestUrl) {
            return response;
        }

        const normalizedRequestUrl = requestUrl.split("?")[0];
        const normalizedApiUrl = appDocketAPI.split("?")[0];

        if (normalizedRequestUrl !== normalizedApiUrl) {
            return response;
        }

        let matches = [];

        try {
            const cloned = response.clone();
            const contentType = cloned.headers.get("content-type") || "";

            if (!contentType.includes("application/json")) {
                return response;
            }

            const data = await cloned.json();
            const serialized = JSON.stringify(data);
            matches = findMatches(serialized);
        } catch (error) {
            console.warn(
                `[appDocket guard] Unable to inspect AppDocket payload: ${error.message}`
            );
            return response;
        }

        if (matches.length > 0) {
            const formatted = formatMatches(matches);
            const message = `[appDocket guard] Forbidden hostnames detected in payload from ${appDocketAPI}. ${formatted}`;
            console.error(message);
            throw new Error(message);
        }

        return response;
    };
}
